import React, { useState } from "react";
import { AddAdditional } from "@coverme/forms";
import "./FacesheetDocuments.scss";
import * as documentService from "../../services/documentService";
import { LoadingBar } from "../LoadingComponents/LoadingBar";
import { DocumentItem, DocumentForm } from "../Documents";

export const FacesheetDocuments = ({
    documents = [],
    documentTypes,
    patientName,
    personId,
    isLoading,
    getDocuments,
    deleteDocument,
    hasDeletePermission,
    customerId,
}) => {
    const [isUploading, setIsUploading] = useState(false);

    function uploadDocument(documentType, documentSubtype, documents) {
        documentService.uploadDocument(customerId, personId, documentType, documentSubtype, documents).then(() => {
            getDocuments(customerId, personId);
            setIsUploading(false);
        });
    }

    function onDeleteDocument(documentId) {
        return deleteDocument(customerId, personId, documentId);
    }

    return (
        <div className="facesheet_documents">
            <div className="uploaded-documents">
                <LoadingBar isLoading={isLoading}>
                    {documents.map(x => (
                        <DocumentItem
                            {...x}
                            key={x.documentId}
                            personId={personId}
                            onDelete={onDeleteDocument}
                            hasDeletePermission={hasDeletePermission}
                        />
                    ))}
                </LoadingBar>
            </div>
            {isUploading && (
                <DocumentForm
                    documentTypes={documentTypes}
                    patientName={patientName}
                    onCancel={() => setIsUploading(false)}
                    onSubmit={uploadDocument}
                />
            )}
            {!isUploading && (
                <div style={{ width: "fit-content" }}>
                <AddAdditional labelText={`Upload a new document`} clickEvent={() => setIsUploading(!isUploading)} />
                </div>
            )}
        </div>
    );
};
